<template>
  <div class="click-outside" :style="`background-color: ${getTranspHexColor(getColor('not-primary'), 0.4)};`" @click.self="$emit('click-outside')">
    <div class="self-centered standard-dialog"
      :style="`
        ${border_radius?`border-radius: ${border_radius};`:''}
        ${width?`width: ${width};`:''}
        ${height?`height: ${height};`:''}
        ${padding?`padding: ${padding};`:''}
        background-color: ${getTranspHexColor(getColor('not-primary'), 0.8)};
        `"
      >
      <!-- :style="`${background_color? `background-color: ${background_color};` : ''}`" -->
      <div class="standard-dialog-content">
        <slot name="content"/>
      </div>
    </div>
  </div>
</template>
<script>
import { TColor } from '@/mixins/TColor.mixin.js';
export default {
  props: [
    'border_radius',
    'width',
    'height',
    'padding'
  ],
  // background_color

  mixins: [
    TColor,
  ],

  methods: {
  }
}
</script>
<style>
.click-outside {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0px;
  left: 0px;
  z-index: 200;
  /* background-color: rgba(0,0,0, 0.4); */
}
.standard-dialog {
  position: fixed;
  height: 75vh;
  width: 75vw;
  /* margin-left: -50vw; */
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  /* background-color: rgba(0,0,0, 0.8); */
  z-index: 10;
  overflow: hidden;
}
.standard-dialog-content {
  position: relative;
  height: 100%;
  /* height: calc(100% - 48px); */
  /* width: 100%; */
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}


</style>
